import {
  RESET_ROLES,
  RESET_ROLE,
  RESET_ERROR,
  GET_ROLES,
  SET_ROLES,
  API_ERROR,
  GET_ROLE,
  SET_ROLE,
  CREATE_ROLE,
  CREATE_ROLE_SUCCESS,
  EDIT_ROLE,
  EDIT_ROLE_SUCCESS,
  DELETE_ROLE,
  DELETE_ROLE_SUCCESS,
} from "./actionTypes";

export const resetRoles = () => {
  return {
    type: RESET_ROLES,
    payload: {},
  };
};

export const resetRole = () => {
  return {
    type: RESET_ROLE,
    payload: {},
  };
};

export const resetError = () => {
  return {
    type: RESET_ERROR,
    payload: {},
  };
};

export const getRoles = (page, qnt, name, description, type) => {
  return {
    type: GET_ROLES,
    payload: { page, qnt, name, description, type },
  };
};
export const setRoles = (data, qtdDefault) => {
  const maxPage = Math.ceil(data.total / qtdDefault);
  var paging = Array.from({ length: maxPage }, (v, k) => k + 1);

  return {
    type: SET_ROLES,
    payload: { ...data, paging },
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const createRole = (newRoleValues) => {
  return {
    type: CREATE_ROLE,
    payload: { newRoleValues },
  };
};
export const createRoleSuccess = (message) => {
  return {
    type: CREATE_ROLE_SUCCESS,
    payload: { message },
  };
};

export const getRole = (idRole, isForm) => {
  return {
    type: GET_ROLE,
    payload: { idRole, isForm },
  };
};
export const setRole = (data) => {
  return {
    type: SET_ROLE,
    payload: { data },
  };
};

export const editRole = (idRole, newRoleValues) => {
  return {
    type: EDIT_ROLE,
    payload: { idRole, newRoleValues },
  };
};
export const editRoleSuccess = (message) => {
  return {
    type: EDIT_ROLE_SUCCESS,
    payload: { message },
  };
};

export const deleteRole = (idRole) => {
  return {
    type: DELETE_ROLE,
    payload: { idRole },
  };
};
export const deleteRoleSuccess = (message) => {
  return {
    type: DELETE_ROLE_SUCCESS,
    payload: { message },
  };
};
